import { Box } from "@mui/material"
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation"
import { useEffect, useState } from "react"

import { useHelper } from "../hooks/use-helper"

/*
This is a hack to "sink" the focus into a random invisible leaf node, so focus is virtually paused as long
as this leaf exists. pausing focus directly could have catastrophic consequences if for any reason the resume
function isn't triggered.

Usage: add Element anywhere on your page
 */

export const usePauseFocus = (ariaLabel?: string) => {
  const [mount, setMount] = useState(false)

  return () => (
    <Box
      ref={(ref) => {
        if (ref) setMount(true)
      }}
    >
      {mount ? <Focusable ariaLabel={ariaLabel}></Focusable> : null}
    </Box>
  )
}

const Focusable = ({ ariaLabel }: { ariaLabel?: string }) => {
  const { focusSelf, ref } = useFocusable({
    isFocusBoundary: true,
  })
  useEffect(() => {
    focusSelf()
  }, [])
  const ariaLabelHelper = useHelper(ariaLabel)

  useEffect(() => {
    if (!ariaLabelHelper.current && ariaLabel) {
      ariaLabelHelper.current = ariaLabel
      setTimeout(() => {
        ref.current.blur()
        setTimeout(() => ref.current.focus(), 200)
      }, 10)
    }
  }, [ariaLabel])

  return <div ref={ref} aria-label={ariaLabel} tabIndex={0}></div>
}
